export function SectionDivider({ title }: { title: string }) {
  return (
    <div className="flex items-center gap-3 my-4">
      <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 dark:text-gray-500 whitespace-nowrap">
        {title}
      </span>
      <div className="flex-1 h-px bg-gray-200 dark:bg-gray-700" />
    </div>
  );
}
